export const contactsData = {
  email: "dommaravenkatesulu22@gmail.com",
  phone: "+91 6366908416",
  address: "Anantapur, Andhra Pradesh",

  sheetAPI:
    // "https://docs.google.com/spreadsheets/d/e/2PACX-1vRP1_DZcoT6Xvp4QkMDR4Fa1dZ99MerUjhjilqDHHjNJQgflR3F65poj-U-wS1R9AiM_zTzjpohGd6h/pubhtml",
    "https://sheets.googleapis.com/v4/spreadsheets/2PACX-1vRP1_DZcoT6Xvp4QkMDR4Fa1dZ99MerUjhjilqDHHjNJQgflR3F65poj-U-wS1R9AiM_zTzjpohGd6h/values/Sheet1!A1:C1?valueInputOption=USER_ENTERED?key=AIzaSyCimxPUSu39tBPo4faq0d-Z-ZrJay0pbug",
};

// "Request is missing required authentication credential. Expected OAuth 2 access token, login cookie or other valid authentication credential. See https://developers.google.com/identity/sign-in/web/devconsole-project."



// api key = AIzaSyCimxPUSu39tBPo4faq0d-Z-ZrJay0pbug

// client Id = 522873269833-cbabbis85fjipqqb6etnb7rjgcfm11aq.apps.googleusercontent.com
// client secret = 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


